import React, { useEffect, useState } from "react";
import * as apicall from "../../components/Apicall";

function Reports() {
  const [reports, setReports] = useState([]);
  const [reportIndex, setReportIndex] = useState("");

  useEffect(() => {
    getReports();
  }, []);

  async function getReports() {
    try {
      const response = await apicall.get(`get_reports`);
      if (response.status === 200) {
        setReports(response.data.data || []);
        setReportIndex(0);
      }
    } catch (error) {
      console.error("Error fetching specializations:", error);
      // toast.error('Failed to fetch specializations');
    }
  }

  // console.log("reports----", reports);

  return (
    <div>
      <div className="d-flex gap-4 align-items-center">
        {reports &&
          reports?.length > 0 &&
          reports?.map((ele, idx) => {
            return (
              <div
                onClick={() => setReportIndex(idx)}
                className={` px-4 py-2 mb-2 cursor-pointer 
                 ${
                   idx === reportIndex
                     ? "btn-danger  text-white"
                     : "text-secondary"
                 }`}
              >
                {ele?.label}
              </div>
            );
          })}
      </div>
      <iframe
        style={{ width: "100%", height: "100dvh" }}
        title={reports[reportIndex]?.label}
        src={reports[reportIndex]?.links}
      ></iframe>
    </div>
  );
}

export default Reports;
